var r,t;function e(){return t?r:(t=1,r=function(r){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(r)})}export{e as __require};
